export const SOURCE_YOUTUBE = 'youtube';
export const SOURCE_VIMEO = 'vimeo';
